import { render, staticRenderFns } from "./IcoPencil.vue?vue&type=template&id=1b102a02"
import script from "./IcoPencil.vue?vue&type=script&lang=js"
export * from "./IcoPencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports